import { UnauthorizedPage } from './UnauthorizedPage';

/**
 * Route-error 403 component. Re-exports `UnauthorizedPage` in its
 * forbidden variant so the two near-duplicate panels share a single
 * implementation. Uses `forbidden` (presence flag) rather than `required`
 * because this component is mounted from the route error boundary which
 * has no knowledge of which tier was demanded — fabricating "admin" was
 * the misleading-URL bug the PR review surfaced.
 */
export function ForbiddenPage() {
  return <UnauthorizedPage forbidden />;
}
